import React, { useState } from "react";

import PopupOptions from "./PopupOptions";
import Triangle from "./Triangle";
import Background from "./Background";

import DateTime from "../time/DateTime";
import {
    popupOptionsShow,
    changePopupOptions,
    show,
    hidden,
} from "./PopupOptions";

import "./_options.scss";
import { getComponentValue } from "../tab_options/settings/Config";

function Options(props) {
    const [lang, setLang] = useState(getComponentValue("language"));

    function handleChangeLang(updatedLang) {
        setLang(updatedLang);
        props.onChangeLang(updatedLang);
    }

    function handleChangeSettings(updatedSettings) {
        props.onChangeSettings(updatedSettings);
    }

    function handleChangeFavorites(updatedFav) {
        props.onChangeFavorites(updatedFav);
    }

    function showPopupOptions(e) {
        if (e.target.className === "btn-options") {
            if (!popupOptionsShow) {
                show(e);
                // showImagesAndFolders()
            } else {
                hidden(e);
            }
            changePopupOptions();
        }
    }

    return (
        <div className="container-options">
            <Background />
            <div className="btn-options" onClick={(e) => showPopupOptions(e)}>
                {(lang === "es") ? "Opciones" : "Options"}
                <PopupOptions onChangeLang={handleChangeLang} onChangeSettings={handleChangeSettings} onChangeFavorites={handleChangeFavorites} />
                <Triangle />
            </div>
            <DateTime lang={lang} />
        </div>
    );
}

export default Options;
